import { useEffect, useState } from "react";
import {
  HashRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import SignIn from "./components/SignIn"; // Adjust the path based on your folder structure
import SignUp from "./components/SignUp"; // Adjust the path based on your folder structure
// import ForgotPassword from "./components/ForgotPassword";
import axios from "axios";
import NavigationBar from "./components/NavigationBar";
// import MyProfile from "./components/MyProfile/MyProfile";
import Dashboard from "./components/Dashboard/Dashboard";
// import Events from "./components/Events/Events";
import OtpSignup from "./components/OtpSignup";
import OtpSignin from "./components/OtpSignin";
// import Profession from "./components/Professions";
import Super_Admin_SignIn from "./components/Super_Admin_SignIn";
import SuperAdminDashboard from "./components/SuperAdmin/SuperAdminDashboard";
import AddAdmin from "./components/Modals/Admin/AddAdmin";
import LomPresidentPage from "./components/Lom_President/LomPresident";
import ZoneTrainersPage from "./components/ZoneTrainers/ZoneTrainers";
import ZoneTrainersPage1 from "./components/ZoneTrainers/ZoneTrainers1";
import EventPage from "./components/Event/Event";
import TrainersEventStatus from "./components/TrainerEvents/TrainerEventStatus";
import EventStatus from "./components/LomPresidentEvents/EventStatus";
import ApprovedZoneTrainerPage from "./components/AdminApprovedZoneTrainer/ApprovedZoneTrainer";
import ViewEventsPage from "./components/ViewLomPresidentEvent/ViewEvents";
import AdminPage from "./components/Admin/AdminPage";
import ContestPage from "./components/Contest/Contest";
import TrainersContestVideo from "./components/TrainersContest/trainersContestVideo";
import TrainersContest from "./components/TrainersContest/trainersContest";
import ProtectedRoute from "./components/protected_route";
function Navigator() {
  const location = useLocation();
  const [header, setHeader] = useState(true); // Default to show header
  // axios.defaults.baseURL = "http://127.0.0.1:5000";
  // sessionStorage.setItem("url", "http://127.0.0.1:5000");
  axios.defaults.baseURL = "https://dceconnect.in/jci_lom_api";
  sessionStorage.setItem("url", "https://dceconnect.in/jci_lom_api");
  useEffect(() => {
    // Hide NavigationBar on SignIn, SignUp, and ForgotPassword pages
    if (
      location.pathname === "/Super_Admin_SignIn" ||
      location.pathname === "/super_admin_signin" ||
      location.pathname === "/super_admin_dashboard" ||
      location.pathname === "/add-admin" ||
      location.pathname === "/profession" ||
      location.pathname === "/" ||
      location.pathname === "/SignUp" ||
      location.pathname === "/forgotpassword" ||
      location.pathname === "/OtpSignup" ||
      location.pathname === "/OtpSignin"
    ) {
      setHeader(false);
    } else {
      setHeader(true);
    }
  }, [location]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <>
      <div style={{ fontFamily: "Lato, sans-serif" }}>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/OtpSignup" element={<OtpSignup />} />
          <Route path="/OtpSignin" element={<OtpSignin />} />
          {/* <Route path="/forgotpassword" element={<ForgotPassword />} /> */}
          {/* <Route path="/super_admin_dashboard" element={<SuperAdminDashboard />}/> */}
          {/* <Route path ="/app" element={< Apps/>} /> */}
        </Routes>

        {/* Conditionally render NavigationBar based on the header state */}
        {header && (
          <NavigationBar
            isOpen={isSidebarOpen}
            toggleSideBarStatus={toggleSidebar}
          />
        )}

        <Routes>
          {/* <Route path="/profession" element={<Profession/>}/> */}
          <Route path="/super_admin_signin" element={<Super_Admin_SignIn />} />
        </Routes>

        <div className={isSidebarOpen ? "sm:ml-64" : ""}>
          <Routes>
            {/* Add your other routes here */}

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/trainersEventStatus"
              element={
                <ProtectedRoute>
                  <TrainersEventStatus />
                </ProtectedRoute>
              }
            />
            {/* <Route path='/myProfile' element={<MyProfile/>} /> */}
            {/* <Route path="/events" element={<Events/>}/> */}
            <Route
              path="/lomPresident"
              element={
                <ProtectedRoute>
                  <LomPresidentPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lompresidentEventStatus"
              element={
                <ProtectedRoute>
                  <EventStatus />
                </ProtectedRoute>
              }
            />
            <Route
              path="/zoneTrainers"
              element={
                <ProtectedRoute>
                  <ZoneTrainersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/zoneTrainers1"
              element={
                <ProtectedRoute>
                  <ZoneTrainersPage1 />
                </ProtectedRoute>
              }
            />
            <Route
              path="/event"
              element={
                <ProtectedRoute>
                  <EventPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/AdminApprovedZoneTrainer"
              element={
                <ProtectedRoute>
                  <ApprovedZoneTrainerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/ViewallEvents"
              element={
                <ProtectedRoute>
                  <ViewEventsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/add-admin"
              element={
                <ProtectedRoute>
                  <AddAdmin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/adminpage"
              element={
                <ProtectedRoute>
                  <AdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contest"
              element={
                <ProtectedRoute>
                  <ContestPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/trainersContest"
              element={
                <ProtectedRoute>
                  <TrainersContest />
                </ProtectedRoute>
              }
            />
            <Route
              path="/trainersContestVideo/:contestId"
              element={
                <ProtectedRoute>
                  <TrainersContestVideo />
                </ProtectedRoute>
              }
            />
          </Routes>
        </div>
      </div>
    </>
  );
}

function App() {
  return (
    <Router>
      <Navigator />
    </Router>
  );
}

export default App;
